var map = {
	"./BGJrPanel1.webp": 1761,
	"./BGJrPanel2.webp": 1762,
	"./BGJrPanel3.webp": 1763,
	"./BrainGymHappyLogo.png": 1286,
	"./DashboardIcon.png": 1764,
	"./English Sharp Shooter Locked.png": 1765,
	"./English Sharp Shooter Unlocked.png": 1766,
	"./Exchange.png": 1397,
	"./HowBGJrHelp.png": 1635,
	"./Ripple.svg": 635,
	"./SignUpKid.png": 1478,
	"./Timer.png": 1767,
	"./TrophyMonthly.svg": 1324,
	"./TrophyYearly.svg": 1325,
	"./affiliate/get-money.png": 1445,
	"./affiliate/hero-section.png": 1444,
	"./affiliate/how-it-works-cropped.png": 1449,
	"./affiliate/international.png": 1447,
	"./affiliate/leadership.png": 1446,
	"./affiliate/success.png": 1448,
	"./apple-store.svg": 649,
	"./avatar.png": 1768,
	"./badges/10 Day Streak Locked.png": 1511,
	"./badges/10 Day Streak Unlocked.png": 1270,
	"./badges/All Rounder Locked.png": 1512,
	"./badges/All Rounder Unlocked.png": 1271,
	"./badges/English Sharp Shooter Locked.png": 1513,
	"./badges/English Sharp Shooter Unlocked.png": 1272,
	"./badges/First 100 Percent Locked.png": 1514,
	"./badges/First 100 Percent Unlocked.png": 1273,
	"./badges/Friendly Locked.png": 1515,
	"./badges/Friendly Unlocked.png": 1274,
	"./badges/Hat Trick Locked.png": 1516,
	"./badges/Hat Trick Unlocked.png": 1275,
	"./badges/Maths Sharp Shooter Locked.png": 1517,
	"./badges/Maths Sharp Shooter Unlocked.png": 1276,
	"./badges/Real World Sharp Shooter Locked.png": 1518,
	"./badges/Real World Sharp Shooter Unlocked.png": 1277,
	"./badges/lock.png": 1510,
	"./best-plan.png": 1769,
	"./bg_gift_subscription.png": 1770,
	"./bg_gift_subscription.svg": 1462,
	"./blog/benifits-of-gamyfie-with-learning.jpg": 1353,
	"./blog/correct-age-for-logical-thinking.jpg": 1354,
	"./blog/five-ways-to-improve-child-decision-making.jpg": 1355,
	"./blog/help-your-children.jpg": 1356,
	"./blog/how-to-negotiate.jpg": 1357,
	"./blog/infulacing-child-iq.jpg": 1358,
	"./blog/tech-children-how-to-think.jpg": 1359,
	"./blog/video-games.jpg": 1360,
	"./bot.png": 1771,
	"./braingym-level-logo.png": 1772,
	"./braingym-logo.webp": 1314,
	"./chat/doubt.svg": 1575,
	"./chat/start-chat.svg": 1552,
	"./circle-tick.png": 1167,
	"./congratulations.png": 1319,
	"./correct-answer.png": 1404,
	"./countries/AE.svg": 654,
	"./countries/AR.svg": 655,
	"./countries/AT.svg": 656,
	"./countries/AU.svg": 657,
	"./countries/BE.svg": 658,
	"./countries/BO.svg": 659,
	"./countries/CA.svg": 660,
	"./countries/CO.svg": 661,
	"./countries/CY.svg": 662,
	"./countries/DE.svg": 663,
	"./countries/EE.svg": 664,
	"./countries/ES.svg": 665,
	"./countries/FI.svg": 666,
	"./countries/FR.svg": 667,
	"./countries/GB.svg": 668,
	"./countries/GR.svg": 669,
	"./countries/GY.svg": 670,
	"./countries/HK.svg": 671,
	"./countries/IE.svg": 672,
	"./countries/IN.svg": 673,
	"./countries/IT.svg": 674,
	"./countries/LT.svg": 675,
	"./countries/LU.svg": 676,
	"./countries/LV.svg": 677,
	"./countries/MT.svg": 678,
	"./countries/MY.svg": 679,
	"./countries/NL.svg": 680,
	"./countries/NZ.svg": 681,
	"./countries/PE.svg": 682,
	"./countries/PH.svg": 683,
	"./countries/PT.svg": 684,
	"./countries/RU.svg": 685,
	"./countries/SA.svg": 686,
	"./countries/SG.svg": 687,
	"./countries/SI.svg": 688,
	"./countries/SK.svg": 689,
	"./countries/US.svg": 690,
	"./countries/UY.svg": 691,
	"./countries/ZA.svg": 692,
	"./countries/null.svg": 693,
	"./crossword/fast-down.png": 1576,
	"./crossword/fast-forward.png": 1577,
	"./declined.gif": 1399,
	"./digital-store/Alert.svg": 1052,
	"./digital-store/ArrowRight.svg": 1267,
	"./digital-store/Bag.png": 1248,
	"./digital-store/Coins.svg": 1110,
	"./digital-store/Empty.svg": 1155,
	"./digital-store/EyeOff.svg": 1578,
	"./digital-store/MysteryBox.svg": 1561,
	"./digital-store/MysteryBoxBG.svg": 1560,
	"./earned-points.png": 1158,
	"./edit-icon.svg": 1156,
	"./emailbox.png": 1461,
	"./english-level-1.png": 1454,
	"./english-level-2.png": 1455,
	"./english-level-3.png": 1456,
	"./english-level-4.png": 1457,
	"./english-level-5.png": 1458,
	"./english-subject-icon.png": 1773,
	"./englishNew.png": 1573,
	"./faq.webp": 1335,
	"./feature-details.png": 1579,
	"./filter.png": 1419,
	"./five_sec_countdown.gif": 1403,
	"./friend.png": 1563,
	"./fun-time.png": 1774,
	"./gift-background.png": 1196,
	"./gift-box.png": 1477,
	"./hero-section.png": 1422,
	"./hero-section.webp": 1374,
	"./home-logo.png": 1775,
	"./home-logo.webp": 205,
	"./horizontalAdd.png": 1776,
	"./image.png": 1777,
	"./invite_dummy.png": 1562,
	"./kool-kid-bust.png": 1395,
	"./level-lock.png": 1778,
	"./loginAvatar.svg": 1385,
	"./logo-sad.png": 1386,
	"./logo.png": 206,
	"./logo_hd.webp": 1106,
	"./logo_old.png": 1779,
	"./looking-for-user.gif": 653,
	"./math-subject.png": 1780,
	"./maths1.png": 1465,
	"./maths2.png": 1466,
	"./maths3.png": 1467,
	"./maths4.png": 1468,
	"./maths5.png": 1469,
	"./mathsNew.png": 1572,
	"./mcq-image-correct.png": 1405,
	"./mcq-image-wrong.png": 1406,
	"./mobViewImage.png": 1781,
	"./my-plan.png": 1470,
	"./news/2.webp": 1782,
	"./news/3.webp": 1783,
	"./news/G944747822.webp": 1784,
	"./news/family_math1_1.webp": 1785,
	"./next-button.png": 1786,
	"./not_responded.gif": 1400,
	"./one-time-registration.png": 1787,
	"./paytm-signup/1.png": 1473,
	"./paytm-signup/2.png": 1474,
	"./paytm-signup/3.png": 1475,
	"./paytm-signup/4.png": 1476,
	"./play-store.svg": 648,
	"./player_joined.gif": 1401,
	"./player_waiting.gif": 1402,
	"./practice-summary/encouragement.jpeg": 1297,
	"./practice-summary/inspiration.jpeg": 1788,
	"./practice-summary/inspiration.png": 1396,
	"./practice-summary/sad.jpeg": 1144,
	"./pricing.svg": 1551,
	"./profile.png": 1789,
	"./progressbar.gif": 1790,
	"./question-cross.png": 1121,
	"./question-tick.png": 1120,
	"./random.png": 1564,
	"./realWorlNew.png": 1571,
	"./realworld.png": 1791,
	"./sad-face.png": 1792,
	"./sample-success-bg.png": 1793,
	"./signup/1.png": 1485,
	"./signup/2.png": 1486,
	"./signup/3.png": 1487,
	"./signup/4.png": 1488,
	"./signup/5.png": 1489,
	"./signup/6.png": 1490,
	"./star-level-icon.png": 1373,
	"./star.svg": 1352,
	"./staugustinesday.webp": 1491,
	"./stories/StoryLock.png": 1794,
	"./stories/character.svg": 1795,
	"./stories/lvl1.svg": 1796,
	"./stories/lvl10.svg": 1797,
	"./stories/lvl13.svg": 1798,
	"./stories/lvl4.svg": 1799,
	"./stories/lvl7.svg": 1800,
	"./stories/points-star.svg": 1407,
	"./story_done.png": 1408,
	"./subscription-cart.png": 1801,
	"./topicIcon.png": 1326,
	"./trade-counter-offer.svg": 1268,
	"./trash/2.jpeg": 1802,
	"./trash/BGJrPanel1.png": 1803,
	"./trash/BGJrPanel2.png": 1804,
	"./trash/BGJrPanel3.png": 1805,
	"./trash/G944747822.jpeg": 1806,
	"./trash/braingym-logo.png": 1807,
	"./trash/family_math1_1.jpeg": 1808,
	"./trash/faq.png": 1809,
	"./trash/hero-section.png": 1810,
	"./trash/logo_hd.png": 1811,
	"./trial.jpg": 1812,
	"./trophy.png": 1421,
	"./under-maintanance.svg": 1492,
	"./vs.png": 652,
	"./waiting.gif": 1398,
	"./why-we-need.png": 1813,
	"./worksheet-english-question.png": 1452,
	"./worksheet-maths-question.png": 1453,
	"./wrong-answer.png": 1409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1760;